module.exports = __webpack_public_path__ + "static/media/logo_dark.48ab7481.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo/logo_dark.svg
// module id = 1831
// module chunks = 3